import React, { useState } from 'react';
import "./associarClienteExistente.scss";
import Field from "../../../../components/field";
import Form from "../../../../components/form";
import Utils from "../../../../helper/validateUtils";
import { verifyClientExistsByCpf } from '../../../../store/associadoPJReducer/actions';
import vm from 'vanilla-masker'

const AssociarClienteExistente = ({ client, updateState, clientExists }) => {
  const [buscando, setBuscando] = useState(false);
  const [cpf, setCpf] = useState(vm.toPattern(client.Cpf || '', '999.999.999-99'));
  
  const searchClient = (name, value) => {
    setCpf(value);
    const v = value.replace(/\D/g, '');
    if (v.length !== 11) return;
    setBuscando(true);
    verifyClientExistsByCpf(v).then((data) => {
      if (data.IdCliente) updateState({ clientExists: true, client:{ ...data, Cpf: v } });
    }).finally(() => setBuscando(false));
  };

  const clear = () => {
    setCpf('');
    updateState({ clientExists: false, client: {} });
  };

  return (
    <Form name="buscaCpf">
      <div className="col">
        <p>Associe um cliente existente ou cadastre um novo</p>
      </div>
      <div className="col-50">
        <Field
          type="cpf"
          placeholder="999.999.999-99"
          label="Buscar por CPF"
          name="buscaCpf"
          disabled={buscando || clientExists}
          value={cpf}
          loading={buscando}
          validateSync={Utils.isCPF}
          mask="999.999.999-99"
          onChange={searchClient}
        />
      </div>
      {clientExists && (
        <div className="col-50 client-data">
          <p className="client-label">Cliente: </p>
          <p className="client-name">{client.Nome}</p>
          <button type="button" onClick={clear}>Limpar</button>
        </div>
      )}
    </Form>
  );
};

export default AssociarClienteExistente;
